import { Address } from "../Address/Address";
import { Customer } from "../Customer/Customer";

export interface Invoice {
  id: number;
  order_id: number;
  customer_id: number;
  customer_name?: string;
  einvoice_id?: string;
  invoice_number: string;
  billing_address_id: number;
  shipping_address_id: number;
  amount_before_discount: number;
  discount: number;
  amount_after_discount: number;
  taxes: number;
  amount: number;
  place_of_supply: string;
  gst_no: string;
  items?: InvoiceItem[];
  services?: InvoiceService[];
  customer?: Customer;
  payments?: InvoicePayment[];
  admin_id: number;
  admin_name?: string;
  date?: Date;
  created_date?: string;
  modified_date?: Date;
  user_id?: number;
  tax_amount?: number;
  total_amount?: number;
  net_amount?: number;
  balance_amount?: number;
  amount_received?: number;
  billing_address?: Address;
  shipping_address?: Address;
  bill_from_address_id?: number;
  bill_from_address_gstin?: string;
  bill_from_address?: Address;
  advance_payment_amount?: number;
  delete_reason?: string;
  reactivate_reason?: string;
  active?: boolean;
}

export interface InvoiceItem {
  invoice_id?: number;
  product_id?: number;
  product_name?: string;
  image_url?: string;
  zoho_id?: any;
  quantity?: number;
  tax_id?: string;
  active?: boolean;
  created_date?: Date;
  modified_date?: Date;
  id?: number;
  name?: string;
  cost_price: number;
  unit_price: number;
  discount: number;
  selling_price: number;
  product_selling_price: number;
  customisation_required?: boolean;
  mrp: number;
  taxes?: number;
  amount: number;
  gst_percentage: number;
  used_quantity?: number;
  sku?: string;
  hsn_code?: string;
  category_id: number;
  category_name?: string;
  desc: string;
  image_urls?: string[];
}

export interface InvoiceService {
  invoice_id?: number;
  service_id?: number;
  service_name?: string;
  name?: string;
  zoho_id?: string;
  quantity?: number;
  tax_id?: string;
  taxes?: number;
  id?: number;
  custom_name?: string;
  cost_price?: number;
  unit_price?: number;
  discount?: number;
  selling_price?: number;
  service_selling_price?: number;
  mrp?: number;
  tax_amount?: number;
  amount?: number;
  gst_percentage?: number;
  sku?: string;
  sac_code?: string;
  active?: boolean;
  created_date?: Date;
  modified_date?: Date;
}

export interface InvoicePayment {
  id?: number;
  invoice_id: number;
  amount: number;
  payment_mode: PaymentMode;
  exchange_rate: number;
  bank_charges?: number;
  recorded_by: number;
  recorded_by_name?: string;
  deleted_by: number;
  deleted_by_name?: string;
  recorded_date?: string;
  active: boolean;
  created_date?: Date;
  modified_date?: Date;
  tds_charges?: number;
  forex_charges?: number;
  other_charges?: number;
  charge_type?: ChargesType | any;
}

export class InvoicePaymentRequest {
  id?: number;
  invoice_id?: number;
  amount?: number;
  payment_mode?: PaymentMode | any;
  exchange_rate?: number;
  bank_charges?: number;
  recorded_by?: number;
  recorded_date?: string;
  deleted_by?: number;
  active?: boolean;
  order_id?: number;
  tds_charges?: number;
  forex_charges?: number;
  other_charges?: number;
  charge_type?: ChargesType | any;
}

export enum PaymentMode {
  KODO = "kodo",
  CHEQUE = "check",
  RAZORPAY = "razorpay",
  STRIPE = "stripe",
  CREDIT_CREDIT = "creditcard",
  BANK_TRANSFER = "banktransfer",
  BANK_REMITTANCE = "bankremittance",
  AUTO_TRANSACTION = "autotransaction",
  OTHERS = "others",
}

export enum ChargesType {
  NONE = "-1",
  BANK_CHARGES = "bank_charges",
  TDS_CHARGES = "tds_charges",
  FOREX_CHARGES = "forex_charges",
  FOREX_GAIN = "forex_gain",
  FOREX_LOSS = "forex_loss",
  OTHER_CHARGES = "other_charges",
}
